import React, { useEffect } from "react";

// Importing Packages
import { v4 as uuidv4 } from "uuid";

//Importing Libraries
var Highcharts = require("highcharts");

function BubbleChart(props) {
  let id = generateRandomGuid();
  function generateRandomGuid() {
    return uuidv4();
  }

  useEffect(() => {
    function renderChart(id,labelx) {
     	Highcharts.chart(`bc-${id}`, {

    chart: {
        type: 'bubble',
        zoomType: 'xy',
        plotBorderWidth: 0,
        backgroundColor: 'transparent',
        // width: 490,
        height: 270
    },

    legend: {
        enabled: false
    },

    title: {
        text: null,
    },

    subtitle: {
        text: null
    },

    accessibility: {
        point: {
            valueDescriptionFormat: '{index}. {point.name}, Avg.Contractor: {point.x}g, sugar: {point.y}g, obesity: {point.z}%.'
        }
    },

    xAxis: {
        gridLineWidth: 1,
        gridLineDashStyle: 'dash',
        plotBorderWidth: 0,
        title: {
            text: null
        },
        labels: {
            format: '{value}',
            style:{
            	color: labelx,
            }
        },
        plotLines: [{
            color: 'transparent',
            dashStyle: null,
            width: 2,
            value: 65,
            label: {
                rotation: 0,
                y: 15,
                style: {
                    fontStyle: 'italic',
          
                },
                
            },
            zIndex: 3
        }],
        accessibility: {
            rangeDescription: 'Range: 30 to 100.'
        }
    },
    
    credits:{
    	enabled: false
    },
    
     exporting:{
    	enabled: false
    },

    yAxis: {
     		gridLineWidth: 1,
    		gridLineDashStyle: 'dash',
        
        startOnTick: false,
        endOnTick: false,
        title: {
            text: null
        },
        labels: {
            format: '{value}',
            style:{
            	color: labelx,
            }
        },
        maxPadding: 0.2,
        plotLines: [{
            color: 'transparent',
            dashStyle: null,
            width: 2,
            value: 50,
            label: {
                align: 'right',
                style: {
                    fontStyle: 'italic',
                   
                },
               
                x: -10
            },
            zIndex: 3
        }],
        accessibility: {
            rangeDescription: 'Range: 10 to 160.'
        }
    },

    tooltip: {
        useHTML: true,
        headerFormat: '<table>',
        pointFormat: '<tr><th colspan="2"><h3>{point.country}</h3></th></tr>' +
            '<tr><th>Avg. Contractor Performance</th><td>{point.x}</td></tr>' +
            '<tr><th>Total Projects:</th><td>{point.y}</td></tr>',
        followPointer: true
    },

    plotOptions: {
        series: {
            dataLabels: {
                enabled: false,
                format: '{point.name}',
                
                style:{
                	color: '#fff'
                }
            }
        }
    },

    series: [{
        data: [
            { x: 60.3, y: 58.7, name: 'RY', country: 'Ar Riyadh' ,color: "#E9631C"},
            { x: 70.5, y: 27.9,  name: 'AJ', country: 'Al Jawf',color:'#1C70A5' },
            { x: 80.8, y: 37.5,  name: 'TB', country: 'Tabuk' ,color:'#1C70A5'},
            { x: 70.4, y: 42.5,  name: 'HA', country: 'Hail' ,color:'#239D9C'},
            { x: 50.3, y: 56.1,  name: 'AQ', country: 'Al Quassam' ,color:'#D60000'},
            { x: 98.4, y: 65.1,  name: 'MD', country: 'Al Madinah' ,color:'#24A0D9'},
            { x: 94.2, y: 18.5,  name: 'AS', country: 'Ash Shariqiyah' ,color:'#D60000'},
            { x: 63.5, y: 33.1, name: 'MK', country: 'Makkah' ,color:'#E9631C'},
            { x: 57.5, y: 58.1, name: 'AB', country: 'Al Bahah' ,color:'#1C70A5'},        
            { x: 79.2, y: 50.6,  name: 'AR', country: 'Asir' ,color:'#D9D9D9'},
            { x: 88.6, y: 60.6,  name: 'JZ', country: 'Jizan' ,color:'#1C70A5'},

        ]
    }]

});
    }
    renderChart(id,props.labelx);
  }, [id,props.labelx]);

  return <div id={`bc-${id}`}></div>;
}

export default BubbleChart;
